module.exports = __webpack_public_path__ + "static/media/Logo-Newspeak-PIcto.cb754942.svg";